var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "text-center " },
    [
      _c("v-modal-contents", {
        ref: "modal_contents_agree",
        scopedSlots: _vm._u([
          {
            key: "close",
            fn: function () {
              return [_c("div")]
            },
            proxy: true,
          },
          {
            key: "title",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use__title " }, [
                  _c("div", { staticClass: "h2_title" }, [
                    _vm._v("Условия использования персональных данных"),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
          {
            key: "content",
            fn: function () {
              return [
                _c("div", { staticClass: "terms_of_use mt-30 " }, [
                  _c("div", { domProps: { innerHTML: _vm._s(_vm.terms) } }),
                  _vm._v(" "),
                  _c("div", { staticClass: "mt-30" }, [
                    _c(
                      "button",
                      {
                        staticClass: "px-30 btn-red",
                        on: {
                          click: function ($event) {
                            return _vm.$refs.modal_contents_agree.modal_open()
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n                        Прочитал\n                    "
                        ),
                      ]
                    ),
                  ]),
                ]),
              ]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "content-class": "dialog_custom dialog_call",
            width: "516",
            relative: "",
            persistent: "",
          },
          model: {
            value: _vm.dialog,
            callback: function ($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      attrs: { action: "#", "lazy-validation": "" },
                      on: {
                        submit: function ($event) {
                          $event.preventDefault()
                        },
                      },
                      model: {
                        value: _vm.valid,
                        callback: function ($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid",
                      },
                    },
                    [
                      _c("section", { staticClass: "call" }, [
                        _c("div", { staticClass: "call__header" }, [
                          _c("h2", { staticClass: "call__title" }, [
                            _vm._v(
                              "\n                                Заказать звонок\n                            "
                            ),
                          ]),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "call__close",
                              on: {
                                click: function ($event) {
                                  _vm.dialog = false
                                },
                              },
                            },
                            [
                              _c(
                                "svg",
                                {
                                  attrs: {
                                    width: "36",
                                    height: "36",
                                    viewBox: "0 0 36 36",
                                    fill: "none",
                                    xmlns: "http://www.w3.org/2000/svg",
                                  },
                                },
                                [
                                  _c("path", {
                                    attrs: {
                                      d: "M17.9991 15.8801L25.4241 8.45508L27.5451 10.5761L20.1201 18.0011L27.5451 25.4261L25.4241 27.5471L17.9991 20.1221L10.5741 27.5471L8.45312 25.4261L15.8781 18.0011L8.45312 10.5761L10.5741 8.45508L17.9991 15.8801Z",
                                      fill: "#52525B",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "call__inner" }, [
                          _c("div", { staticClass: "call__form" }, [
                            _c(
                              "label",
                              {
                                staticClass: "call__label",
                                attrs: { for: "name" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "call__input",
                                  attrs: {
                                    rules: _vm.nameRulesRu,
                                    required: "",
                                    id: "name",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                                            ФИО *\n                                        "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.name,
                                    callback: function ($$v) {
                                      _vm.name = $$v
                                    },
                                    expression: "name",
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "label",
                              {
                                staticClass: "call__label",
                                attrs: { for: "tel" },
                              },
                              [
                                _c("v-text-field", {
                                  staticClass: "call__input",
                                  attrs: {
                                    rules: _vm.tel_inputRulesRu,
                                    required: "",
                                    id: "tel",
                                    oninput:
                                      "this.value = this.value.replace(/[^\\d+]/g,'');",
                                  },
                                  scopedSlots: _vm._u([
                                    {
                                      key: "label",
                                      fn: function () {
                                        return [
                                          _vm._v(
                                            "\n                                            Телефон *\n                                        "
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ]),
                                  model: {
                                    value: _vm.tel_input,
                                    callback: function ($$v) {
                                      _vm.tel_input = $$v
                                    },
                                    expression: "tel_input",
                                  },
                                }),
                              ],
                              1
                            ),
                          ]),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "w-100 mt-30",
                            class: _vm.captchaPassed ? "" : "error-captcha",
                            attrs: { id: "captcha-container" },
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "form_upload__item" },
                            [
                              _c("v-checkbox", {
                                attrs: {
                                  rules: [
                                    function (v) {
                                      return !!v || "Это обязательный пункт"
                                    },
                                  ],
                                  required: "",
                                  color: "red",
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "customLabelForm" },
                                          [
                                            _vm._v(
                                              "\n                                            Я выражаю согласие с "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href: "javascript:void(0);",
                                                  target: "_blank",
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.$refs.modal_contents_agree.modal_open(
                                                      "scroll_false"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "условиями\n                                            использования"
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              " моих персональных данных для обработки данного\n                                            обращения ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206,\n                                            Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,\n                                            этаж 2), я ознакомлен и выражаю согласие с\n                                            "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "position-relative zi-1",
                                                attrs: { href: _vm.policy },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.linkOpen(
                                                      _vm.policy
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Политикой конфиденциальности"
                                                ),
                                              ]
                                            ),
                                            _vm._v(
                                              " и\n                                            "
                                            ),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "position-relative zi-1",
                                                attrs: { href: _vm.agreement },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.linkOpen(
                                                      _vm.agreement
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "Пользовательским соглашением."
                                                ),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.checkbox,
                                  callback: function ($$v) {
                                    _vm.checkbox = $$v
                                  },
                                  expression: "checkbox",
                                },
                              }),
                              _vm._v(" "),
                              _c("v-checkbox", {
                                staticClass: "mt-0",
                                attrs: { color: "red" },
                                scopedSlots: _vm._u([
                                  {
                                    key: "label",
                                    fn: function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "customLabelForm" },
                                          [
                                            _vm._v(
                                              "\n                                            Я выражаю согласие на информирование меня о продуктах, акциях,\n                                            выгодных предложениях, новостях ООО «Компания Нова Ролл» (ИНН\n                                            5038050970, адрес: 141206, Московская область, г. Пушкино,\n                                            Кудринское шоссе, д. 2а, стр. 5, этаж 2) и партнеров.\n                                        "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                    proxy: true,
                                  },
                                ]),
                                model: {
                                  value: _vm.consentToInform,
                                  callback: function ($$v) {
                                    _vm.consentToInform = $$v
                                  },
                                  expression: "consentToInform",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "call__box" }, [
                            _c(
                              "button",
                              {
                                staticClass: "call__btn btn-red",
                                attrs: { disabled: !_vm.valid },
                                on: { click: _vm.validate },
                              },
                              [
                                _vm._v(
                                  "\n                                    Отправить\n                                "
                                ),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }